<template>
  <section class="relative text-white py-20 px-6 bg-no-repeat bg-cover bg-center ">
    <div class="max-w-7xl mx-auto flex flex-col items-center text-center mb-32">
      <!-- Título -->
      <div class="mb-6">
        <h1 class="text-3xl md:text-5xl font-extrabold mb-4">CONTRATO DE VPS E DEDICADO</h1>
        <p class="text-lg mt-2">Utilize sua hospedagem conforme as boas práticas e as políticas da Integrator Host.</p>
      </div>
    </div>
  </section>
</template>
